// 260825nrai: IR overview — client-side role filter (rows stay, right column hides)

const irRoleFilterState = { employee: '', institution: '' };

function applyIrRoleFilter(panel, kind) {
  if (!panel) {
    return;
  }

  const zone = panel.querySelector('[data-ir-role-filter-zone]');
  if (!zone) {
    kind = '';
  } else if (kind && !zone.querySelector(`a[data-kind-filter="${kind}"]`)) {
    kind = '';
  }

  panel.querySelectorAll('.ir-list-item').forEach((item) => {
    const matches = !kind || (item.dataset.irRole || '') === kind;
    item.hidden = !matches;
  });

  if (zone) {
    zone.dataset.activeKind = kind || '';
    zone.querySelectorAll('a[data-kind-filter]').forEach((link) => {
      link.classList.toggle('active', (link.dataset.kindFilter || '') === (kind || ''));
    });
  }

  const viewmode = panel.dataset.irViewmode;
  if (viewmode) {
    irRoleFilterState[viewmode] = kind || '';
  }
}

function bindIrRoleFilterZone(zone) {
  if (zone.dataset.bound === '1') {
    return;
  }
  zone.dataset.bound = '1';
  zone.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-kind-filter]');
    if (!link || !zone.contains(link)) {
      return;
    }
    event.preventDefault();
    applyIrRoleFilter(zone.closest('[data-ir-scope]'), link.dataset.kindFilter || '');
  });
}

function initInstitutionResponsibilityFilters(options = {}) {
  document.querySelectorAll('[data-ir-role-filter-zone]').forEach(bindIrRoleFilterZone);

  document.querySelectorAll('[data-ir-scope]').forEach((panel) => {
    const zone = panel.querySelector('[data-ir-role-filter-zone]');
    const viewmode = panel.dataset.irViewmode;
    let kind = '';
    if (options.preserve && viewmode && Object.prototype.hasOwnProperty.call(irRoleFilterState, viewmode)) {
      kind = irRoleFilterState[viewmode] || '';
    } else if (zone) {
      kind = zone.dataset.activeKind || '';
    }
    applyIrRoleFilter(panel, kind);
  });
}

export { initInstitutionResponsibilityFilters };
